import { render, staticRenderFns } from "./LocusZoomCredibleSetsPanel.vue?vue&type=template&id=5e2f8531&"
import script from "./LocusZoomCredibleSetsPanel.vue?vue&type=script&lang=js&"
export * from "./LocusZoomCredibleSetsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e2f8531')) {
      api.createRecord('5e2f8531', component.options)
    } else {
      api.reload('5e2f8531', component.options)
    }
    module.hot.accept("./LocusZoomCredibleSetsPanel.vue?vue&type=template&id=5e2f8531&", function () {
      api.rerender('5e2f8531', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lz/panels/LocusZoomCredibleSetsPanel.vue"
export default component.exports